export const sortKeysByValue = (data) => {
  return Object.entries(data)
    .sort(([,a],[,b]) => b-a)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
}